// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const CvssSecurityRequirementSchema = z.enum(['X','L','M','H'] as const);

export type CvssSecurityRequirementType = `${z.infer<typeof CvssSecurityRequirementSchema>}`

export default CvssSecurityRequirementSchema;
